var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"41e781768ddee4feb775ec2c911be430a0d84206"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yepic-frontend@launch-ist"]={id:"41e781768ddee4feb775ec2c911be430a0d84206"};
      